import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { AppDispatch } from '@/store/store';
import { fetchResultByAttemptKey } from '@/store/reducers/resultSlice';
import Result from '@/pages/result/Result';
import ErrorWithReload from '@/components/molecules/ErrorWithReload/ErrorWithReload';
import { selectResultError, selectResultIsFetching } from '@/store/selectors/resultSelectors';
import Loader from '@/components/atoms/UI/Loader/Loader';

const ResultByAttempt: React.FC = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { attemptKey } = useParams<{ attemptKey: string }>();
	const error = useSelector(selectResultError);
	const isFetching = useSelector(selectResultIsFetching);
	const [isLoaded, setIsLoaded] = useState(false); // Флаг, когда запрос завершён

	useEffect(() => {
		if (attemptKey) {
			dispatch(fetchResultByAttemptKey(attemptKey)).then(() => {
				setIsLoaded(true);
			});
		}
	}, [attemptKey]);

	if (error) {
		return <ErrorWithReload error={error} transparent />;
	}

	if (!isLoaded || isFetching) {
		return <Loader dark />
	}

	return <Result fromAttempt={true} />
};

export default ResultByAttempt;